/**
 * use-ai-assistant.ts — "AI Trợ lý" nội bộ: nhân viên hỏi đáp/tra cứu tự do (sản phẩm, kiến thức công ty) hoặc chạy TÁC VỤ dựng sẵn
 * (báo cáo hôm nay / 7 ngày, việc cần xử lý — máy chủ lấy số liệu theo quyền + phạm vi của người hỏi). Backend:
 * GET /ai/assistant/tasks, POST /ai/assistant/ask (assistant-routes.ts, assistant-tasks.ts).
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'

export interface AssistantTurn {
  role: 'user' | 'assistant'
  text: string
}

export interface AskAssistantResult {
  reply: string
  usedSources: { kb: number; products: number }
}

/** Tác vụ dựng sẵn người dùng được phép chạy (máy chủ đã lọc theo quyền). */
export interface AssistantTask {
  key: string
  label: string
  prompt: string
}

export function useAskAssistant() {
  return useMutation({
    mutationFn: async (input: { message: string; botId?: string; history?: AssistantTurn[]; task?: string }) =>
      (await api.post<AskAssistantResult>('/ai/assistant/ask', input)).data,
  })
}

export function useAssistantTasks(enabled = true) {
  return useQuery<AssistantTask[]>({
    queryKey: ['ai', 'assistant', 'tasks'],
    enabled,
    staleTime: 5 * 60_000,
    queryFn: async () => (await api.get<{ tasks: AssistantTask[] }>('/ai/assistant/tasks')).data.tasks,
  })
}
